/**
 * helper implemetations
 */

export const defaultTableData = () => {
  return {columns: [], values: []};
};